export const PLAYER_BOTTOM_HEIGHT = 90;
